<template>
  <div id="onestop-detail" :class="{ 'clear-header': isWechatBrowser }">
    <my-header
      :title="title"
      v-if="!isWechatBrowser"
      :showBack="true"
    ></my-header>
    <div class="default-top-bg">
      <div class="onestop-case-info">
        <div class="onestop-case-title">{{ onestopCase.title }}</div>
        <div v-if="onestopCase.price > 0" class="onestop-case-price">
          {{ onestopCase.price }}<span class="unit">元/㎡</span>
        </div>
      </div>
    </div>
    <div class="guarantee-part general-box-shadow">
      <div class="guarantee-item">
        <img
          class="icon-promise-box"
          src="../../assets/icon/icon-construction.png"
        />
        <div>基础施工质保{{ companyInfo.constructionGuarantee }}年</div>
      </div>
      <div class="guarantee-item">
        <img
          class="icon-promise-box"
          src="../../assets/icon/icon-electricity.png"
        />
        <div>水电工程质保{{ companyInfo.hydropowerGuarantee }}年</div>
      </div>
      <div class="guarantee-item">
        <img
          class="icon-promise-box"
          src="../../assets/icon/icon-umbrella.png"
        />
        <div>防水工程质保{{ companyInfo.waterproofGuarantee }}年</div>
      </div>
    </div>

    <div
      class="company-info general-box-shadow"
      @click="toOnestopCompany(companyInfo.id)"
    >
      <img class="company-avatar" :src="imgUrl + companyInfo.logo" />
      <div class="company-less-info">
        <span class="company-name">{{ companyInfo.name }}</span>
        <div class="company-auth">
          <div class="platform-auth">
            <img src="../../assets/appointment/icon-platform-auth.png" />
            <div>平台认证</div>
          </div>
          <div class="company-deposit">
            <img src="../../assets/appointment/icon-deposit-auth.png" />
            <div>9 万</div>
          </div>
        </div>
      </div>
      <div class="evaluate-score">
        <div class="score">5.0</div>
        评分
      </div>
    </div>
    <div class="general-tab-part onestop-tap">
      <div
        class="tab-item"
        @click="isLabel(0)"
        :class="{ selected: isLabelNum == 0 }"
      >
        装修详情
      </div>
      <!--<div v-if="companyInfo.id!='2'" class="tab-item" @click="isLabel(2)" :class="{'selected':isLabelNum == 2}">精选案例</div>-->
      <div
        class="tab-item"
        @click="isLabel(3)"
        :class="{ selected: isLabelNum == 3 }"
      >
        精选案例
      </div>
      <div
        class="tab-item"
        @click="isLabel(2)"
        :class="{ selected: isLabelNum == 2 }"
      >
        施工案例
      </div>
      <div
        class="tab-item"
        @click="isLabel(4)"
        :class="{ selected: isLabelNum == 4 }"
      >
        装修评价
      </div>
    </div>
    <div class="case-content" v-if="isLabelNum == 0">
      <div v-html="onestopCase.content"></div>
    </div>
    <div
      class="detail-materials"
      v-if="isLabelNum == 1"
      style="padding-bottom: 2rem"
    >
      <div
        class="category-list"
        v-for="(category, categoryIndex) in categoryList"
      >
        <div class="category-name">
          <div class="arrow-right">
            <img
              src="../../assets/icon/arrow-right.png"
              class="mine-image"
              style="margin-top: 0.02rem;display: flex;"
            />
          </div>
          <div>{{ category.name }}</div>
          <div class="arrow-left">
            <img
              src="../../assets/icon/arrow-left.png"
              class="mine-image"
              style="margin-top: 0.02rem;display: flex;"
            />
          </div>
        </div>
        <div class="brand-content">
          <div class="brand-title">
            有{{ category.materialList.length }}个品牌可选
          </div>
          <div class="brand-list">
            <div
              v-for="(brand, index) in category.materialList"
              @click="selectMaterialBrand(categoryIndex, brand.id)"
              class="brand-item"
              :class="{
                'brand-item-active': category.selectBrandId == brand.id,
              }"
            >
              <img
                v-if="brand.image.length > 0 && brand.image.length > 60"
                :src="brand.image"
                class="mine-image"
              />
              <img
                v-if="brand.image.length > 0 && brand.image.length < 60"
                :src="imgUrl + brand.image"
                class="mine-image"
              />
              <div
                class="brand-item-active-icon"
                :hidden="category.selectBrandId != brand.id"
              >
                <img
                  src="../../assets/icon/brand-active.png"
                  class="mine-image"
                />
              </div>
            </div>
          </div>
          <div v-if="category.selectBrand.example" class="brand-example">
            <img
              v-if="
                category.selectBrand.example.length != null &&
                  category.selectBrand.example.length > 60
              "
              :src="category.selectBrand.example"
              class="mine-image"
            />
            <img
              v-if="
                category.selectBrand.example.length != null &&
                  category.selectBrand.example.length < 60
              "
              :src="imgUrl + category.selectBrand.example"
              class="mine-image"
            />
          </div>
          <div class="brand-info">
            <div class="brand-info-name">{{ category.selectBrand.name }}</div>
            <div class="brand-info-detail">
              <div>{{ category.selectBrand.intro }}</div>
            </div>
          </div>
          <div
            v-if="category.selectBrand.productList.length > 0"
            class="brand-product-list"
          >
            <div
              style="margin-left: 0.3rem"
              v-for="product in category.selectBrand.productList"
            >
              <div @click="showProductDetail(product)" class="product-image">
                <img
                  v-if="
                    product.image &&
                      product.image.length > 0 &&
                      product.image.length > 60
                  "
                  :src="product.image"
                  class="mine-image"
                />
                <img
                  v-if="
                    product.image &&
                      product.image.length > 0 &&
                      product.image.length < 60
                  "
                  :src="imgUrl + product.image"
                  class="mine-image"
                />
              </div>
              <div class="product-name">{{ product.showName }}</div>
              <div class="product-intro">{{ product.model }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="categoryList.length == 0" class="black-page">
        <img src="../../assets/icon-no-img.png" />
        <div class="tip">该案例暂无相关主材信息!</div>
      </div>
    </div>
    <GangmasterCaseList :company-id="companyId" v-if="isLabelNum == 2" />
    <div class="project-list" v-if="isLabelNum == 3">
      <div
        class="project-item general-box-shadow"
        v-for="article in articleList"
        @click="openArticle(article)"
      >
        <img v-if="article.cover" :src="imgUrl + article.cover" class="cover" />
        <img v-else="" src="../../assets/icon-project-default-cover.png" />
        <div class="project-info">
          <div class="name">{{ article.title }}</div>
        </div>
      </div>
      <div v-if="articleList.length == 0" class="black-page">
        <img src="../../assets/icon-no-img.png" />
        <div class="tip">暂无该方案的相关案例!</div>
      </div>
    </div>
    <CompanyEvaluateList :company-id="companyId" v-if="isLabelNum == 4" />
    <div class="product-info" v-if="isShowProductDetail">
      <img
        v-if="productDetail.image.length > 0 && productDetail.image.length > 60"
        class="product-info-image"
        :src="productDetail.image"
      />
      <img
        v-if="productDetail.image.length > 0 && productDetail.image.length < 60"
        class="product-info-image"
        :src="imgUrl + productDetail.image"
      />
      <div class="product-info-intro">{{ productDetail.intro }}</div>
      <div class="confirm-btn" @click="closeProductDetail">确定</div>
    </div>
    <div v-if="isShowProductDetail" class="material-detail-box"></div>
    <div
      class="btn-order"
      @click="
        openOnestopReservation(
          onestopCase.companyId,
          onestopCaseId,
          onestopCase.title,
          onestopCase.price
        )
      "
    >
      立即预约
    </div>
  </div>
</template>

<script>
import { imgUrl, shareIcon } from "../../config";
import { Toast } from "mint-ui";
import Header from "../../components/header/Header";
import OnestopProjectService from "../../service/onestop/OnestopProjectService";
import projectService from "../../service/customer/ProjectService";
import CompanyService from "../../service/company/CompanyService";
import shareService from "../../service/share/ShareService";
import caseArticleService from "../../service/onestop/OnestopCaseArticleService";
import GangmasterCaseList from "./components/GangmasterCaseList";
import CompanyEvaluateList from "./components/CompanyEvaluateList";

export default {
  name: "OnestopCompanyDetail",
  components: {
    CompanyEvaluateList,
    GangmasterCaseList,
    "my-header": Header,
  },
  data() {
    return {
      isLabelNum: 0,
      imgUrl: imgUrl,
      shareIcon: shareIcon,
      onestopCaseId: "",
      onestopCase: {},
      categoryList: [],
      selectBrand: {},
      productDetail: {},
      isShowProductDetail: false,
      companyId: "",
      companyInfo: { tagList: [] },
      isWechatBrowser: this.$verfyBrowserType(),
      caseTitle: "",
      casePrice: "",
      title: "",
      onestopProjectList: [],
      articleList: [],
    };
  },
  created() {
    this.onestopCaseId = this.$route.query.id;
    this.companyId = this.$route.query.companyId;
    this.title = this.caseTitle + "详情";
  },
  beforeMount() {
    this.getOnestopCaseDetail(this.onestopCaseId);
    this.initWechatShare();
    this.getCaseArticleList(this.onestopCaseId);
  },
  methods: {
    isLabel(num) {
      if (num == 1) {
        this.isLabelNum = 1;
      } else if (num == 0) {
        this.isLabelNum = 0;
      } else if (num == 2) {
        this.isLabelNum = 2;
      } else if (num == 3) {
        this.isLabelNum = 3;
      } else {
        this.isLabelNum = 4;
      }
    },
    openOnestopReservation(companyId, onestopCaseId, caseTitle, casePrice) {
      if (!!this.global.isMiniProgrm) {
        wx.miniProgram.navigateTo({
          url: `/pages/onestop/book/book?onestopCaseId=${onestopCaseId}&caseTitle=${caseTitle}&casePrice=${casePrice}&companyId=${companyId}`,
        });
      } else {
        this.$router.push({
          name: "OnestopReservation",
          query: { companyId, onestopCaseId, caseTitle, casePrice },
        });
      }
    },
    toOnestopCompany(companyId) {
      // this.$router.push({name:'OnestopCompany',query:{companyId}});
    },
    async getCaseArticleList(id) {
      let { code, data } = await caseArticleService.getList(id);
      if (code == 0) {
        this.articleList = data;
      } else {
        Toast("获取案例信息失败");
      }
    },
    async getCompanyInfo(id) {
      let { code, data } = await CompanyService.getCompanyInfo(id);
      if (code == 0) {
        if (data.company.name.length > 8) {
          data.company.name = data.company.name.substring(0, 8) + "...";
        }
        this.companyInfo = data.company;
      } else {
        Toast("获取装修公司信息失败");
      }
    },
    async getOnestopCaseDetail(id) {
      let result = await OnestopProjectService.getOnestopCaseDetail(id);
      if (result.code == 0) {
        this.onestopCase = result.data;
        this.getCompanyInfo(this.onestopCase.companyId);
        if (this.onestopCase.title.length > 10) {
          this.onestopCase.title =
            this.onestopCase.title.substring(0, 10) + "...";
        }
        this.categoryList = this.onestopCase.categoryList;
        for (let index in this.categoryList) {
          let category = this.categoryList[index];
          category.selectBrandId = category.materialList[0].id;
          category.selectBrand = category.materialList[0];
        }
      } else {
        Toast("获取装修方案详情失败");
      }
    },
    selectMaterialBrand(categoryIndex, brandId) {
      let categoryList = this.categoryList;
      this.categoryList = [];
      categoryList[categoryIndex].selectBrandId = brandId;
      var brandList = categoryList[categoryIndex].materialList;
      for (var index in brandList) {
        var brand = brandList[index];
        if (brand.id === brandId) {
          categoryList[categoryIndex].selectBrandId = brandId;
          categoryList[categoryIndex].selectBrand = brand;
        }
      }
      this.categoryList = categoryList;
    },
    showProductDetail(product) {
      this.isShowProductDetail = true;
      this.productDetail = product;
    },
    closeProductDetail() {
      this.isShowProductDetail = false;
      this.productDetail = {};
    },
    openCaseProject(project) {
      this.$router.push({
        name: "OnestopProjectDetail",
        query: {
          onestopProjectId: project.id,
          companyId: project.companyId,
          type: project.type,
        },
      });
    },
    openArticle(article) {
      this.$router.push({
        name: "ArticleDetail",
        query: {
          articleId: article.articleId,
          title: article.title,
          summary: "",
        },
      });
    },
    async getProjectList() {
      let result = await projectService.getOnestopProjectList(
        "",
        "",
        "5",
        this.companyId
      );
      if (result.code == "0") {
        this.onestopProjectList = result.data.result;
      } else {
        Toast("获取案例失败，请稍后重试");
      }
    },
    async getSupervisorProjectList() {
      let result = await projectService.getOnestopProjectList(
        "",
        "",
        "5",
        this.companyId
      );
      if (result.code == "0") {
        this.onestopProjectList = result.data.result;
      } else {
        Toast("获取案例失败，请稍后重试");
      }
    },
    async initWechatShare() {
      let title = this.caseTitle + this.casePrice + "元/平"; // 分享标题
      let desc = "水木家居商城装修套餐"; // 分享描述
      let link = window.location.href; // 分享链接
      link = link.replace(/#/, "?#");
      await shareService.wechatShare(title, desc, link, this.shareIcon);
    },
  },
};
</script>
<style lang="scss">
@import "../../assets/style/common.scss";
.btn-order {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 0.96rem;
  line-height: 1rem;
  text-align: center;
  background: rgb(254, 172, 0);
  color: white;
  font-size: 0.36rem;
}
#onestop-detail {
  padding-bottom: 0.96rem;
  background-color: white;
  color: #7f7d7c;
  font-size: 0.28rem;
  .clear-header {
    margin-top: -1rem;
  }
  .default-top-bg {
    padding-left: 0.3rem;
    font-size: 0.36rem;
    font-weight: bold;
    color: white;
    line-height: 0.5rem;
    .onestop-case-info {
      width: 6.9rem;
      display: flex;
      justify-content: space-between;
      padding-top: 0.3rem;
      .onestop-case-tag {
        width: 1.36rem;
        height: 0.45rem;
        line-height: 0.5rem;
        background: white;
        text-align: center;
        border-radius: 0.45rem;
        color: #feac00;
        font-size: 0.24rem;
        font-weight: lighter;
      }
      .onestop-case-title {
        padding-left: 0.2rem;
      }
      .onestop-case-price {
        padding-left: 1.2rem;
        .unit {
          font-size: 0.28rem;
        }
      }
    }
  }
  .guarantee-part {
    display: flex;
    justify-content: space-around;
    width: 6.9rem;
    height: 1.9rem;
    margin: -0.57rem auto 0;
    text-align: center;
    background: white;
    color: #191818;
    img {
      width: 0.82rem;
      height: 0.82rem;
    }
    .guarantee-item {
      margin-top: 0.24rem;
    }
  }
  .company-info {
    position: relative;
    display: flex;
    width: 6.9rem;
    height: 1.9rem;
    margin: 0.33rem auto 0;
    border-radius: 0.08rem;
    box-shadow: 0rem 0.02rem 0.07rem 0rem rgba(0, 0, 0, 0.1);
    .company-avatar {
      width: 1.3rem;
      height: 1.3rem;
      border-radius: 0.06rem;
      margin: 0.3rem 0.2rem;
    }
    .company-less-info {
      margin-top: 0.4rem;
      font-size: 0.28rem;
      color: #7f7d7c;
      .company-name {
        font-weight: bold;
        font-size: 0.36rem;
        color: #191818;
      }
      .company-auth {
        display: flex;
        width: 2.95rem;
        height: 0.4rem;
        line-height: 0.45rem;
        border-radius: 0.4rem;
        margin-top: 0.19rem;
        background: #e0dedc;
        font-size: 0.24rem;
        color: #191818;
        font-weight: bold;
        img {
          width: 0.27rem;
          height: 0.28rem;
          margin-top: 0.06rem;
          margin-right: 0.1rem;
        }
        .platform-auth {
          display: flex;
          padding-left: 0.23rem;
        }
        .company-deposit {
          display: flex;
          padding-left: 0.29rem;
        }
      }
    }
    .evaluate-score {
      position: absolute;
      right: 0.21rem;
      background: url("../../assets/icon-evaluate-bg.png") no-repeat;
      width: 0.58rem;
      height: 0.8rem;
      line-height: 0.25rem;
      background-size: 100%;
      font-size: 0.18rem;
      color: white;
      text-align: center;
      .score {
        margin-top: 0.05rem;
        font-size: 0.24rem;
        font-weight: bold;
      }
    }
  }
  .onestop-tap {
    margin-top: 0.1rem;
    line-height: 0.95rem;
    font-size: 0.32rem;
    .selected {
      font-size: 0.36rem;
    }
  }
  .case-content {
    width: 6.9rem;
    margin: 0 auto;
    img {
      width: 100%;
      height: auto;
    }
    .detail-title {
      font-size: 0.4rem;
      padding: 0.2rem;
    }
  }
  .no-msg {
    background: white;
    color: #878e99;
    font-size: 0.28rem;
    text-align: center;
    margin-bottom: 0.5rem;
    padding-top: 0.5rem;
    img {
      width: 1.5rem;
      margin-bottom: 0.5rem;
    }
  }
  .category-list {
    .mine-image {
      width: 100% !important;
      height: 100% !important;
    }
    .category-name {
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
      background-color: #fff;
      margin-top: 0.2rem;
      font-size: 0.4rem;
      color: #333;
      text-align: center;
      font-weight: 600;
      padding: 0.4rem;
    }
    .arrow-right {
      margin-right: 0.15rem;
      width: 0.36rem;
      height: 0.36rem;
      position: relative;
    }
    .arrow-left {
      margin-left: 0.15rem;
      width: 0.36rem;
      height: 0.36rem;
      position: relative;
    }
    .arrow-right::before {
      width: 1.8rem;
      border-top: 1px solid #d2d2d2;
      display: block;
      content: " ";
      position: absolute;
      left: -1.72rem;
      top: 0px;
      margin-top: 0.19rem;
    }
    .arrow-left::after {
      width: 1.8rem;
      border-top: 1px solid #d2d2d2;
      display: block;
      content: " ";
      position: absolute;
      left: 0.28rem;
      top: 0px;
      margin-top: 0.19rem;
    }

    .brand-content {
      margin-bottom: 0.2rem;
      padding-bottom: 0.5rem;
    }
    .brand-title {
      width: 100%;
      text-align: center;
      color: #f07843;
      font-size: 0.24rem;
    }
    .brand-list {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-around;
      align-items: center;
      margin-top: 0.2rem;
      font-size: 0.4rem;
      color: #333;
      text-align: center;
      font-weight: 600;
    }
    .brand-item {
      border: 1px solid #f07843;
      width: 2.2rem;
      height: 0.85rem;
      position: relative;
      margin-top: 0.1rem;
    }
    .brand-item-active {
      border-width: 4px;
    }
    .brand-item-active-icon {
      position: absolute;
      bottom: -0.02rem;
      right: -0.02rem;
      width: 0.44rem;
      height: 0.44rem;
    }
    .brand-example {
      padding: 0.25rem;
      height: 4.2rem;
    }
    .brand-info {
      text-align: left;
      background-color: #fff;
      padding: 0.15rem 0.3rem;
    }
    .brand-info-name {
      font-size: 0.34rem;
      font-weight: 600;
      padding: 0.15rem 0px;
      color: #333;
    }
    .brand-info-detail {
      font-size: 0.24rem;
      color: #666;
      padding: 0.15rem 0px;
      padding-bottom: 0.5rem;
      border-bottom: 1px dashed #ddd;
    }

    .brand-product-list {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      background-color: #fff;
      margin-top: 0.3rem;
      width: 7.2rem;
      overflow-x: scroll;
    }
    .brand-left,
    .brand-right {
      width: 0.34rem;
      height: 1.8rem;
      position: relative;
      padding-right: 0.2rem;
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
    }
    .brand-right {
      padding-right: 0px;
      padding-left: 0.2rem;
    }
    .brand-arrow-image {
      width: 100%;
      height: 0.34rem;
    }
    .product-list {
      flex-grow: 1;
    }
    .product-scroll-view {
      white-space: nowrap;
      max-width: 5.95rem;
    }
    .product-item {
      width: 1.82rem;
      display: inline-block;
      margin-left: 0.25rem;
    }
    .product-item-first {
      width: 1.82rem;
      display: inline-block;
      margin-left: 0px;
    }
    .product-image {
      height: 1.82rem;
      width: 2rem;
    }
    .product-name,
    .product-intro {
      font-size: 0.3rem;
      color: #333;
      text-align: center;
      display: block;
    }
    .product-name {
      margin-top: 0.2rem;
    }
    .product-modal-image {
      width: 100%;
      height: 4rem;
    }
  }
  .product-info {
    width: 80%;
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 100;
    background: white;
    -webkit-transform: translate3d(-50%, -50%, 0);
    transform: translate3d(-50%, -50%, 0);
    border-radius: 0.1rem;
    .product-info-image {
      margin-top: 0.7rem;
      width: 5rem;
    }
    .product-info-intro {
      width: 5rem;
      margin: 0.2rem auto;
      color: #878e99;
      font-size: 0.3rem;
    }
    .confirm-btn {
      height: 0.8rem;
      color: #5fcf48;
      line-height: 0.8rem;
      font-size: 0.32rem;
      border-top: solid 1px #eaeaeb;
    }
  }
  .material-detail-box {
    overflow: hidden;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 99;
  }
  .btn-appointment {
    position: fixed;
    bottom: 2rem;
    right: 0.7rem;
    width: 0.88rem;
    height: 0.88rem;
    line-height: 1rem;
    text-align: center;
    background-color: #feac00;
    border-radius: 0.88rem;
    box-shadow: 0px 2px 6px 0px rgba(167, 75, 0, 0.57);
    color: white;
  }
}
</style>
